import { ErrorComponent } from './../error.component';
import { ERROR_ROUTE_PARAMETRIZED } from './error-route.const';
import { Route } from '@angular/router';

export const ERROR_ROUTING: Route = {
  path: ERROR_ROUTE_PARAMETRIZED,
  title: 'ERROR.TITLES.DEFAULT',
  component: ErrorComponent,
  children: []
};
